import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { Menu } from '@mui/material';
const HoverMenu = /*#__PURE__*/React.forwardRef(function HoverMenu(props, ref) {
  var _props$PaperProps;
  return /*#__PURE__*/React.createElement(Menu, _extends({}, props, {
    ref: ref,
    style: {
      pointerEvents: 'none',
      ...props.style
    },
    PaperProps: {
      ...props.PaperProps,
      style: {
        pointerEvents: 'auto',
        ...((_props$PaperProps = props.PaperProps) === null || _props$PaperProps === void 0 ? void 0 : _props$PaperProps.style)
      }
    }
  }));
});
export default HoverMenu;